import { errorHelpers } from '@approvalmax/utils';
import { useSetAtom } from 'jotai';
import { schemas } from 'modules/data';
import { useUploadAttachment } from 'shared/data/webApp/v1';
import { handleFileUploadLimits } from 'shared/helpers';

import { netSuiteAttachmentUploadingLineIdsState } from '../../NetSuiteExpenseReportRequestForm.states';

export const useExpenseLinesUploadAttachments = () => {
    const { mutateAsync: uploadAttachment } = useUploadAttachment();

    const setUploadingLineIds = useSetAtom(netSuiteAttachmentUploadingLineIdsState);

    const onUploadAttachment = async (lineId: string, files: File[]) => {
        setUploadingLineIds((previousIds) => [...previousIds, lineId]);

        const newFiles = handleFileUploadLimits(files);

        if (newFiles.length > 0) {
            try {
                const formData = new FormData();

                formData.append('file', newFiles[0]);

                const response = await uploadAttachment({ body: formData });
                const attachments = response.Attachments.map(schemas.request.mapAttachment);

                return attachments[0] || null;
            } catch (error) {
                errorHelpers.captureException(error);
            } finally {
                setUploadingLineIds((previousIds) => previousIds.filter((id) => id !== lineId));
            }
        }

        return null;
    };

    return {
        onUploadAttachment,
    };
};
